export const MIGRATION_ENABLED = true;

